import { render, staticRenderFns } from "./supportTickets.vue?vue&type=template&id=0cef5f5b"
import script from "./supportTickets.vue?vue&type=script&lang=js"
export * from "./supportTickets.vue?vue&type=script&lang=js"
import style0 from "./supportTickets.vue?vue&type=style&index=0&id=0cef5f5b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports